import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Autocomplete
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { MAIN_URL } from "../../../Configurations/Urls";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import axios from "axios";
import toast from "react-hot-toast";
import Header from "../../DataLayouts/Header";


function ProjectTemplateTasksForm({mode}) {

  const navigate = useNavigate();
  const { id } = useParams(); // if id is present => edit mode
  

  const { userData } = useAuthStore();

  console.log("full uer data is : ", userData);

  const org = userData?.organization;

  const fetchProjectTemplateTasks = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${MAIN_URL}/api/project-management/project-template-tasks/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = res.data?.data;

      if (data) {
        setFormData({
          organization_id: data.organization_id || "",
          organization_entity_id: data.organization_entity_id || "",
          organization_project_template_id: data.organization_project_template_id || "",
          organization_project_template_milestone_id: data.organization_project_template_milestone_id || "",
          organization_project_task_template_id: data.organization_project_task_template_id || "",
          remarks: data.remarks || ""
        });
      }

    } catch (error) {
      toast.error("Failed to fetch project template data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if ((mode === "edit" || mode === "edit-v2" || mode == "view") && id) {
      fetchProjectTemplateTasks();
    }
  }, [mode, id]);

  const [formData, setFormData] = useState({
    organization_id: org?.organization_id || "",
    organization_entity_id: "",
    organization_project_template_id: "",
    organization_project_template_milestone_id: "",
    organization_project_task_template_id: "",
    remarks: ""
  });

  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const validateForm = () => {

    const errors = {};

    if (!formData.organization_project_template_id) errors.organization_project_template_id = "Project Template is required";
    if (formData.remarks && formData.remarks.length > 255)
      errors.remarks = "Max 255 characters allowed";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };


  // Submit form
  const handleSubmit = async () => {
    setFormErrors({});

    if (!validateForm()) {
      toast.error("Please fix the validation errors.");
      return;
    }

    let organization_entity_id = userData?.organization?.
      entities?.organization_entity_id || null;

    setBtnLoading(true);
    try {

      const token = localStorage.getItem("token");

      if (mode === "edit") {
        await axios.put(`${MAIN_URL}/api/project-management/project-template-tasks/${id}`, { ...formData, organization_entity_id, organization_id: org?.organization_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Project Template Tasks updated");
      } else {
        await axios.post(`${MAIN_URL}/api/project-management/project-template-tasks`, { ...formData, organization_entity_id, organization_id: org?.organization_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Project Template Tasks added");
      }

      navigate("/project-template-tasks");
    } catch (err) {
      if (err.response?.status === 422) {
        setFormErrors(err.response.data.errors);
      } else {
        toast.error("Operation failed");
      }
    }
    setBtnLoading(false);
  };


  const [selectOptions, setSelectOptions] = useState({
    ProjectTemplates: [],
    ProjectTemplateMilesStones: [],
    ProjectTaskTemplates: [],
  })

  console.log("selectOptions is : " , selectOptions);
  

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };


  const fetchProjectTemplates = async () => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-templates`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });

      console.log("response ProjectTemplates is : ", response);

      setSelectOptions((prev) => ({ ...prev, ProjectTemplates: response.data.data }));
    } catch (e) {
      console.error("Failed to load ProjectTemplates");
    }
  };

  const fetchProjectTemplateMileStone = async (organization_project_template_id) => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-template-milestone`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
          organization_project_template_id
        },
      });

      console.log("response ProjectTemplateMilesStones is : ", response);

      setSelectOptions((prev) => ({ ...prev, ProjectTemplateMilesStones: response.data.data }));
    } catch (e) {
      console.error("Failed to load ProjectTemplateMilesStones");
    }
  };

  const fetchProjectTaskTemplate = async () => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-task-template`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id
        },
      });

      console.log("response ProjectTaskTemplates is : ", response);

      setSelectOptions((prev) => ({ ...prev, ProjectTaskTemplates: response.data.data }));
    } catch (e) {
      console.error("Failed to load ProjectTaskTemplates");
    }
  };

  useEffect(() => {
    fetchProjectTemplates();
  }, [org?.organization_id]);

  useEffect(() => {
    fetchProjectTaskTemplate();
  }, [org?.organization_id]);

  useEffect(() => {
    if (formData?.organization_project_template_id) {
      fetchProjectTemplateMileStone(formData?.organization_project_template_id);
    }
  }, [formData?.organization_project_template_id]);


  return (
    <Box px={4} py={4}>
      <Header
        mode={mode}
        updateMessage={"Project Template Tasks"}
        addMessage={"Project Template Tasks"}
        homeLink={"/project-template-tasks"}
        homeText={"Project Template Task"}
      />

      {loading ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper elevation={4} sx={{ p: 3 }}>
              <Grid container spacing={2}>

                

<Autocomplete
  fullWidth
  disabled={mode === "view"}
  options={selectOptions?.ProjectTemplates || []}
  getOptionLabel={(option) => option.template_name || ""}
  isOptionEqualToValue={(option, value) =>
    option.organization_project_template_id ===
    value.organization_project_template_id
  }
  value={
    selectOptions?.ProjectTemplates?.find(
      (pt) =>
        pt.organization_project_template_id ===
        formData.organization_project_template_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      organization_project_template_id:
        newValue?.organization_project_template_id || "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Project Template *"
      error={!!formErrors.organization_project_template_id}
      helperText={formErrors.organization_project_template_id}
    />
  )}
/>


             

<Autocomplete
  fullWidth
  options={selectOptions?.ProjectTemplateMilesStones || []}
  getOptionLabel={(option) => option.milestone_title || ""}
  isOptionEqualToValue={(option, value) =>
    option.organization_project_template_milestone_id ===
    value.organization_project_template_milestone_id
  }
  disabled={
    !formData.organization_project_template_id || mode === "view"
  }
  value={
    selectOptions?.ProjectTemplateMilesStones?.find(
      (pt) =>
        pt.organization_project_template_milestone_id ===
        formData.organization_project_template_milestone_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      organization_project_template_milestone_id:
        newValue?.organization_project_template_milestone_id || "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Project Template Milestone"
      error={!!formErrors.organization_project_template_milestone_id}
      helperText={
        formData.organization_project_template_id &&
        selectOptions?.ProjectTemplateMilesStones?.length === 0
          ? "No Project Template Milestone Available for Selected Project Template"
          : !formData.organization_project_template_id
          ? "Select Project Template First"
          : formErrors.organization_project_template_milestone_id
      }
    />
  )}
/>



<Autocomplete
  fullWidth
  disabled={mode === "view"}
  options={selectOptions.ProjectTaskTemplates || []}
  getOptionLabel={(option) => option.task_title || ""}
  isOptionEqualToValue={(option, value) =>
    option.organization_project_task_template_id ===
    value.organization_project_task_template_id
  }
  value={
    selectOptions.ProjectTaskTemplates?.find(
      (pt) =>
        pt.organization_project_task_template_id ===
        formData.organization_project_task_template_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      organization_project_task_template_id:
        newValue?.organization_project_task_template_id || "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Project Task Template *"
      error={!!formErrors.organization_project_task_template_id}
      helperText={formErrors.organization_project_task_template_id}
    />
  )}
/>


                {/* <TextField
                  fullWidth
                  type="number"
                  name="task_order"
                  label="Task Order "
                  value={formData.task_order}
                  onChange={handleChange}
                  error={!!formErrors.task_order}
                  helperText={formErrors.task_order}
                />

                <TextField
                  fullWidth
                  type="number"
                  name="task_quantity"
                  label="Task Quantity "
                  value={formData.task_quantity}
                  onChange={handleChange}
                  error={!!formErrors.task_quantity}
                  helperText={formErrors.task_quantity}
                />

                <TextField
                  fullWidth
                        disabled={true}
                  type="number"
                  name="total_task_estimated_minutes"
                  label="Total Task Estimated Minutes "
                  value={formData.total_task_estimated_minutes}
                  onChange={handleChange}
                  error={!!formErrors.total_task_estimated_minutes}
                  helperText={formErrors.total_task_estimated_minutes}
                /> */}

                <TextField
                disabled={mode == "view"}
                  fullWidth
                  multiline
                  minRows={3}
                  label="Remarks "
                  name="remarks"
                  value={formData.remarks}
                  onChange={handleChange}
                  error={!!formErrors.remarks}
                  helperText={formErrors.remarks}
                />

              </Grid>
              {mode !== "view" && <Button
                variant="contained"
                color="primary"
                size="medium"
                onClick={handleSubmit}
                disabled={loading || btnLoading}
                sx={{
                  borderRadius: 2,
                  minWidth: 120,
                  textTransform: "capitalize",
                  fontWeight: 500,
                  mt: 2
                }}
              >
                {loading || btnLoading ? (
                  <CircularProgress size={22} sx={{ color: "#fff" }} />
                ) : mode === "edit" ? (
                  "Update"
                ) : (
                  "Submit"
                )}
              </Button>
              }
              

            </Paper>
          </Grid>
        </Grid>
      )}

    </Box>
  )
}

export default ProjectTemplateTasksForm